'use client';

import { useEffect, useState } from 'react';
import dynamic from 'next/dynamic';

const AdminViewerBar = dynamic(() => import('./AdminViewerBar'), { ssr: false });

export default function AdminGate() {
  const [isAdmin, setIsAdmin] = useState(false);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    let cancelled = false;

    async function check() {
      try {
        const res = await fetch('/api/admin/session', { cache: 'no-store' });
        if (!res.ok) return;
        const data = await res.json();
        if (!cancelled) setIsAdmin(Boolean(data?.isAdmin));
      } finally {
        if (!cancelled) setChecked(true);
      }
    }

    check();
    return () => {
      cancelled = true;
    };
  }, []);

  if (!checked || !isAdmin) return null;
  return <AdminViewerBar />;
}
